import React, { useState } from 'react';
import { Modal, Form, Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import dayjs from 'dayjs';
import BasicInfoSection from './sections/BasicInfoSection';
import TimeInfoSection from './sections/TimeInfoSection';
import FinancialInfoSection from './sections/FinancialInfoSection';

const AirwayBillForm = ({
  visible,
  onCancel,
  onOk,
  form,
  editingBill,
  batches,
  loading,
  ports,
  customers
}) => {
  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: '32px' }}>
          <span>{editingBill ? '编辑空运单' : '新建空运单'}</span>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      onOk={onOk}
      width={1200}
      confirmLoading={loading}
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 10 }}
        wrapperCol={{ span: 14 }}
      >
        <BasicInfoSection 
          ports={ports} 
          customers={customers} 
          batches={batches}
          form={form}
        />
        <TimeInfoSection form={form} />
        <FinancialInfoSection />
      </Form>
    </Modal>
  );
};

export default AirwayBillForm;
